define([
    './directives/FeatureToggler'
], FeatureToggler => {
    return angular.module('edge.platform.featuredetection', [])
        .directive('gwFeatureToggler', FeatureToggler);
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/featuredetection/module.js